var lastHash = '';

$(function () {
    window.onhashchange = hashChanged;
});

$(".featThumbBox img").lazyload({
    threshold: 0,
    effect: 'fadeIn',
    data_attribute: 'lazy',
    failure_limit: 60
});

$(document).ajaxStop(function () {
    $(".featThumbBox img").lazyload({
        threshold: 0,
        effect: 'fadeIn',
        data_attribute: 'lazy',
        failure_limit: 60
    });
});

$(".pagingLink, .pagingRight, .pagingLeft, .pagingFirst, .pagingLast").click(function (e) {
    if (!$.support.leadingWhitespace) {
        return;
    }
    e.preventDefault();
    var url = window.location.href.split('/');
    var href = '';
    var hashes = this.href.split('/');
    var landingPage = false;
    if (window.location.href.indexOf('#') == -1) {
        if (!parseInt(url[url.length - 1])) {
            landingPage = true;
        }
        if (landingPage == false) {
            window.location = e.srcElement.href;
        }
        else {
            window.location.hash = '/' + hashes[hashes.length - 2] + '/' + hashes[hashes.length - 1];
        }
    }
    else {
        window.location.hash = '/' + hashes[hashes.length - 2] + '/' + hashes[hashes.length - 1];
    }
});


$('.itemInfoHover').hover(
    function () {
        $(this).fadeTo(1, 1);
    },
    function () {
        $(this).fadeTo(1, 0);
    }
);

function hashChanged() {
    var newHash = location.hash;
    if (newHash != lastHash) {
        lastHash = newHash;
        LoadProducts();
    }
}

function LoadProducts() {
    var url = window.location.href.replace("#", "");
    $.ajax({
        async: true,
        cache: false,
        type: 'GET',
        url: url,
        dataType: 'html',
        timeout: 30000,
        success: function (data) {
            $('#items').html(data);
            $('html, body').animate({ scrollTop: ($('#items').offset().top) }, 100);
            $('html, body').animate({ scrollTop: '125px' }, 100);
        }
    });
}